import { render, staticRenderFns } from "./DataExport.vue?vue&type=template&id=077d7d5b&scoped=true"
import script from "./DataExport.vue?vue&type=script&lang=js"
export * from "./DataExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077d7d5b",
  null
  
)

export default component.exports